import React, { Component } from 'react';

import firebase from 'firebase/app';
import 'firebase/auth';
import { withRouter } from "react-router-dom";
import MediaQuery from 'react-responsive';
import * as constants from '../Root/Const'
import * as firebaseManager from '../../API/FirebaseManager'
import * as network from '../../API/NetworkRequests';

import {connect} from "react-redux";
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/userActions';
import * as companiesActions from '../../actions//companiesAction';

import Login from './Login';
import LoginMobile from './LoginMobile';
import LoginDialogs from './LoginDialogs';

var unsubscribe


class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            shouldShowErrorDialog: false,
            errorObject: {title: "", message: ""},
            shouldShowAccountNeedsVerifiedDialog: false,
            shouldShowforgotPasswordDialog: false,
            forgotPassword: "",
            shouldShowCompanyListDialog: false,
            arrayOfCompanies: [],
            shouldShowSnackBar: false,
            snackBarMessage: "",
            loading: false,
            selectedCompanyID: "",
            redirectURL: this.props.location.redirectURL,
        };

        this.userNameTextChanged = this.userNameTextChanged.bind(this)
        this.passwordTextChanged = this.passwordTextChanged.bind(this)
        this.didPressEnter = this.didPressEnter.bind(this)
        this.navCreateAccount = this.navCreateAccount.bind(this)
        this.signIn = this.signIn.bind(this)
        this.sendVerificationEmail = this.sendVerificationEmail.bind(this)
        this.closeDialogs = this.closeDialogs.bind(this)
        this.sendForgotPasswordEmail = this.sendForgotPasswordEmail.bind(this)
        this.updateforgotPassword = this.updateforgotPassword.bind(this)
        this.showforgotPasswordDialog = this.showforgotPasswordDialog.bind(this)
        this.companyRadioButtonChange = this.companyRadioButtonChange.bind(this)
        this.navToApp = this.navToApp.bind(this)
    }

    componentDidMount() {
        //check if user is signed in
        unsubscribe = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                // User is signed in.

                if (user.emailVerified) {
                    firebaseManager.getCompaniesFor(user.uid).then(value => {

                        //this gets the company info for the ids just returned 
                        return this.props.companiesActions.getCompaniesInfoForUser(value)

                    }).then(values => {

                        if (this.props.companies.connectedCompanies.length > 1) {
                            this.setState({ shouldShowCompanyListDialog: true, selectedCompanyID: this.props.companies.connectedCompanies[0].companyID.toString()  })
                        } else if (this.props.companies.connectedCompanies.length === 1)  {
                            this.setState({ selectedCompanyID: this.props.companies.connectedCompanies[0].companyID.toString() })
                            this.navToApp()
                        } else {
                            //no active companies
                            this.setState({ shouldShowErrorDialog: true, errorObject: {title: "No Active Company", message: "We couldn't find any active companies attached to your profile. If you believe this is an error please contact the company you believe to be enrolled with."} })
                        }

                    }).catch(error => {
                        this.setState({ errorObject: {title: "Error Retrieving Data", message: error.message}, shouldShowErrorDialog: true })
                    });
                } else {
                    this.setState({ shouldShowAccountNeedsVerifiedDialog: true })
                }

            } else {
                // No user is signed in.
                
            }
        });
        //end of checking if user is signed in

    }

    componentWillUnmount() {
        unsubscribe();
    }


    userNameTextChanged(event) {
        this.setState({ username: event.target.value })
    }

    passwordTextChanged(event) {
        this.setState({ password: event.target.value })
    }

    didPressEnter(event) {
        if(event.key === 'Enter'){
            this.signIn()
        }
    }

    navCreateAccount() {
        this.props.history.push(constants.createAccountPage);
    }

    signIn() {

        this.setState({loading: true})

        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => {
            return firebase.auth().signInWithEmailAndPassword(this.state.username, this.state.password)
        }).then(user => {

            this.setState({loading: false})

        }).catch(error => {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // [START_EXCLUDE]
            if (errorCode === 'auth/wrong-password') {
                this.setState({
                    shouldShowErrorDialog: true,
                    errorObject: {title: "", message: "Wrong username or password"},
                    loading: false,
                    password: "",
                })
            } else {
                this.setState({
                    shouldShowErrorDialog: true,
                    errorObject: {title: "", message: errorMessage},
                    loading: false,
                    password: "",
                })
            }  
           
        });
    }

    navToApp(){

        this.setState({ shouldShowCompanyListDialog: false })
        network.loginAnalytics(this.state.selectedCompanyID)
        
        this.props.companiesActions.setCurrentCompany(this.state.selectedCompanyID)
        this.props.currentUserActions.getUserDataForCurrentCompany(firebase.auth().currentUser.uid, this.state.selectedCompanyID).then(value =>{
            
            if (this.state.redirectURL){
                this.props.history.push(this.state.redirectURL);
            } else {
                if (this.props.currentUser.role === 4 && !this.props.currentUser.region) {
                    this.props.history.push(constants.selectRegionPage);
                } else if (this.props.currentUser.role === 4 ) {
                    if (this.props.companies.currentCompany.hidePointsFromRealtors) {
                        this.props.history.push(constants.registrationPage);
                    } else if (this.props.companies.currentCompany.useBonusLevels) {
                        this.props.history.push(constants.bonusLevelsPage);
                    } else {
                        this.props.history.push(constants.myPointsPage);
                    }
                } else if (this.props.currentUser.role === 3 && !this.props.currentUser.managerUID) {
                    this.props.history.push(constants.selectManagerPage);
                } else if (this.props.currentUser.role === 3 && this.props.companies.currentCompany.hidePointsFromSales) {
                    this.props.history.push(constants.registrationPage);
                } else {
                    if (this.props.currentUser.role === 2 && this.props.companies.currentCompany.hidePointsFromManagers) {
                        this.props.history.push(constants.registrationPage);
                    } else if (this.props.currentUser.role === 1 && this.props.companies.currentCompany.hidePointsFromAdmins) {
                        this.props.history.push(constants.registrationPage);
                    } else {
                        this.props.history.push(constants.realtorsPage);
                    }
                }
                
            }
        }).catch(error => {
            this.setState({errorObject:{title: "Error Retrieving Data", message: error.message}, shouldShowErrorDialog: true })
        });

        
    }

    showforgotPasswordDialog(){
        this.setState({ shouldShowforgotPasswordDialog: true })
    }

    closeDialogs(){
        this.setState({ shouldShowErrorDialog: false, shouldShowAccountNeedsVerifiedDialog: false, shouldShowforgotPasswordDialog: false, shouldShowCompanyListDialog: false, shouldShowSnackBar: false})
    }

    sendVerificationEmail() {
        this.setState({ shouldShowSnackBar: true, snackBarMessage: "Verification email sent" })

        var user = firebase.auth().currentUser;

        network.resendVerificationEmail(user.email).then(response => {
            //the email has been sent successfully 
        }).catch(error => {
            this.setState({ 
                shouldShowSnackBar: true, 
                snackBarMessage: "There was an error sending verification email" 
            })
        })
    }

    sendForgotPasswordEmail() {
        if (this.state.forgotPassword) {

            this.setState({ shouldShowSnackBar: true, snackBarMessage: "Password reset email sent", shouldShowforgotPasswordDialog: false })
            
            firebase.auth().sendPasswordResetEmail(this.state.forgotPassword).then(() =>  {
                //the email has been sent successfully
            }).catch(error => {
                // An error happened.
                this.setState({
                    shouldShowSnackBar: true,
                    snackBarMessage: "There was an error sending reset email.",
                })
            });
        } 
    }

    updateforgotPassword(event){
        this.setState({forgotPassword: event.target.value })
    }

    companyRadioButtonChange = event => {
        this.setState({ selectedCompanyID: event.target.value });
    };
 

    render(){

        return (
            <div> 
                <MediaQuery query={constants.max_width}>
                    <LoginMobile 
                        userNameTextChanged = {this.userNameTextChanged}
                        passwordTextChanged = {this.passwordTextChanged}
                        didPressEnter = {this.didPressEnter}
                        navCreateAccount = {this.navCreateAccount}
                        signIn = {this.signIn}
                        showforgotPasswordDialog={this.showforgotPasswordDialog}
                        loading={this.state.loading}
                    />
                </MediaQuery>
                <MediaQuery query={constants.min_width}>
                    <Login
                        userNameTextChanged = {this.userNameTextChanged}
                        passwordTextChanged = {this.passwordTextChanged}
                        didPressEnter = {this.didPressEnter}
                        navCreateAccount = {this.navCreateAccount}
                        signIn = {this.signIn}
                        showforgotPasswordDialog={this.showforgotPasswordDialog}
                        loading={this.state.loading}
                    />
                </MediaQuery>
                
                <LoginDialogs
                    shouldShowErrorDialog={this.state.shouldShowErrorDialog} 
                    errorTitle={this.state.errorObject.title}
                    errorMessage={this.state.errorObject.message}
                    closeDialogs={this.closeDialogs}
                    shouldShowAccountNeedsVerifiedDialog={this.state.shouldShowAccountNeedsVerifiedDialog}
                    sendVerificationEmail={this.sendVerificationEmail}
                    shouldShowforgotPasswordDialog={this.state.shouldShowforgotPasswordDialog}
                    sendForgotPasswordEmail={this.sendForgotPasswordEmail}
                    updateforgotPassword={this.updateforgotPassword}

                    shouldShowCompanyListDialog={this.state.shouldShowCompanyListDialog}
                    selectCompany={this.navToApp}
                    arrayOfCompanies={this.props.companies.connectedCompanies} 
                    selectCompanyRadioButtonChange={this.companyRadioButtonChange}
                    selectedCompanyID={this.state.selectedCompanyID}
                    shouldShowSnackBar={this.state.shouldShowSnackBar} 
                    snackBarMessage={this.state.snackBarMessage}
                />


            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        currentUser: state.currentUser,
        companies: state.companies
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
        currentUserActions: bindActionCreators(userActions, dispatch),
        companiesActions: bindActionCreators(companiesActions, dispatch)
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginPage));



// WEBPACK FOOTER //
// ./src/components/Login/LoginPage.js